export default __webpack_public_path__ + "static/media/MahlwerckPicture.2a2dfc96.jpg";